<!--
 * @Descripttion: 实名信息，开户信息详情
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="auth-status">
    <BaseForm label-position="right">
      <div style="display: flex">
        <div>
          <BaseFormItem prop="" label="终端服务人员">
            <BaseInput disabled :model-value="formData.name"></BaseInput>
          </BaseFormItem>
        </div>
        <div>
          <BaseFormItem prop="" label="手机号">
            <BaseInput disabled :model-value="formData.phone"></BaseInput>
          </BaseFormItem>
        </div>
      </div>
      <BaseFormItem prop="" label="身份证号">
        <BaseInput disabled :model-value="formData.cardId"></BaseInput>
      </BaseFormItem>
      <BaseFormItem prop="" label="身份证照片">
        <BaseImage
          style="width: 180px; height: 100px; margin-right: 40px"
          :src="formData.cardIdFront"
          :preview-src-list="[formData.cardIdFront]"
        ></BaseImage>
        <BaseImage
          style="width: 180px; height: 100px"
          :src="formData.cardIdBack"
          :preview-src-list="[formData.cardIdBack]"
        ></BaseImage>
      </BaseFormItem>
      <BaseFormItem prop="" label="银行卡号">
        <BaseInput disabled :model-value="formData.bankCardNum"></BaseInput>
      </BaseFormItem>
      <BaseFormItem prop="" label="银行名称">
        <BaseInput disabled :model-value="formData.bankInfo"></BaseInput>
      </BaseFormItem>
    </BaseForm>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseImage } from 'xrk-components';
import { allianceUserRnv } from '../data-source/apis';
// 声明 prop 属性
const props = withDefaults(
  defineProps<{
    userId: number;
  }>(),
  {
    userId: null
  }
);

const formData = ref({
  name: '',
  phone: '',
  cardId: '',
  cardIdFront: '',
  cardIdBack: '',
  bankCardNum: '',
  bankInfo: ''
});

const getInfo = async () => {
  const { data } = await allianceUserRnv({
    userId: props.userId
  });
  formData.value = data;
};
getInfo();
</script>
<style lang="scss"></style>
